import { render } from "./User_add.vue?vue&type=template&id=4bc90305"
import script from "./User_add.vue?vue&type=script&lang=js"
export * from "./User_add.vue?vue&type=script&lang=js"
script.render = render

export default script